import { App } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

export default {
  install(app: App<Element>): any {
    app.use(VueReCaptcha as any, { siteKey: window.captchaKey })
  }
}
